import React, { useState } from 'react';
import "../styles/recentWork.css"
import { useNavigate } from 'react-router-dom'
import CaseStudyRecentWork from '../components/CSRecentWork'
import Footer from '../components/Footer'
import Nav from '../components/Nav'

const projectTypes = [
  "All",
  "Digital Marketing",
  "Web Design",
  "Logo Design & Branding",
  "Graphic Design",
  "Photography",
  "Video"
];

const industries = [
  "All",
  "Automotive",
  "Creative",
  "Non-Profit",
  "Media",
  "Tourism",
  "Tech",
  "Fashion",
  
 ];


const RecentWork = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("Type of Project"); // active tab
  const [activeFilter, setActiveFilter] = useState("All"); // active filter

  const handleContactBtn = () => {
    navigate("/get-in-touch")
  }

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setActiveFilter("All"); // reset filter when tab changes
  }

  const handleFilterClick = (filter) => {
    setActiveFilter(filter);
  }

  // Choose filter options based on active tab
  const filterOptions = activeTab === "Type of Project" ? projectTypes : industries;

  return (
    <>
      <section className='recent-website-wrapper'>
        <Nav/>

        <section className="recent-work-wrapper ">
          <h2 className="recent-work-title">Recent Work</h2>

          <div className="filter-tabs">
            <button
              className={`filter-tab ${activeTab === "Type of Project" ? "active" : ""}`}
              onClick={() => handleTabClick("Type of Project")}
            >
              Type of Project
            </button>
            <button
              className={`filter-tab ${activeTab === "Type of Industry" ? "active" : ""}`}
              onClick={() => handleTabClick("Type of Industry")}
            >
              Type of Industry
            </button>
          </div>

          <div className="category-filters">
            <ul className="filter-list">
              {filterOptions.map((filter) => (
                <li
                  key={filter}
                  className={activeFilter === filter ? "active" : ""}
                  onClick={() => handleFilterClick(filter)}
                >
                  {filter}
                </li>
              ))}
            </ul>
          </div>
        </section>

        <CaseStudyRecentWork activeTab={activeTab} activeFilter={activeFilter}/>

        <section className="booking-wrapper">
          <div className="booking-content">
            <h3>Let's get to work</h3>
            <p>Ready to get started? Book a Discovery Call so we can learn more about your needs and discuss how we can help.</p>
            <button className="get-started-btn" onClick={handleContactBtn}>
              Get Started <span className="plus-icon">+</span>
            </button>
          </div>
        </section>

        <Footer/>
      </section>
    </>
  )
}

export default RecentWork;
